export default __webpack_public_path__ + "static/studyoffice-study4-8bda92421e3501e941dae8dfd6e430af.jpg";